export default function senateReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_SENATE":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
